import { map } from 'rxjs/operators';

/**
 * Transforms a JavascriptObject into a instance of a specific object
 * @param Class the class of the new Object
 * @param params optional parameters for instancing the object
 * @returns the same as the input, but as an actual instance
 */
export function factory<T>(Class: any, ...params: any[]) {
  return map<T, T>((result: any) => {


    if (typeof result === 'object') {
      if (result.records && Array.isArray(result.records)) {
        // GenericPageableResponse or GenericResponse
        result.records = result.records.map((res: T) => {
          const obj: T = new Class(...params);
          Object.keys(res).forEach(key => obj[key] = res[key]);
          return obj;
        });
      } else if (result.record && typeof result.record === 'object') {
        // GenericResponse
        const obj: T = new Class(...params);
        Object.keys(result.record).forEach(key => obj[key] = result.record[key]);
        result.record = obj;
      } else if (Array.isArray(result)) {
        // Array
        result = result.map((res: T) => {
          const obj: T = new Class(...params);
          Object.keys(res).forEach(key => obj[key] = res[key]);
          return obj;
        });
      } else {
        // Other
        const obj: T = new Class(...params);
        Object.keys(result).forEach(key => obj[key] = result[key]);
        result = obj;
      }
    }

    return result;


  });
}
